module.exports = __webpack_public_path__ + "media/images/ui__textArrowDownLight-2223759bdfc51bd90d4c25ecb804680a.png";